document.querySelectorAll('.cus_variant_swatch').forEach(function (el) {
  el.addEventListener('click', function () {
    var variantUrl = this.getAttribute('data-variant-url');
    if (!variantUrl) return;
 
    var card = this.closest('.product-card-item') || this.closest('.product-card');
    if (!card) return;
 
    var link = card.querySelector('.cus-prd-card-img');
    if (link) {
      link.setAttribute('href', variantUrl);
    }
  });
});